export class NetworkError extends Error {}
export class UnauthorizedError extends Error {}
export class ForbiddenError extends Error {}
export class ClownTrialError extends Error {}
export class ChangePasswordError extends Error {}
export class RecurlyAccountNotFoundError extends Error {}
export class RecurlyTransactionError extends Error {
  type = 'transaction'
}
